import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Custom hook to use Google Analytics through GTM
export const useGoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view through GTM dataLayer
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        event: 'pageView',
        page: location.pathname + location.search
      });
    }
  }, [location]);
};

export default useGoogleAnalytics;
